'use client';

import React from 'react';
import { AccountInfo } from 'components/commercetools-ui/organisms/account/types/types';
import ContactUsPage from 'components/commercetools-ui/organisms/contact-us';
import { TasticProps } from 'frontastic/tastics/types';

const ContactUsTastic = ({ data }: TasticProps<AccountInfo>) => {
  return (
      <ContactUsPage data={data} />
  );
};

export default ContactUsTastic;
